// pt-BR translations for common.en.ts. Keep keys in lockstep with the EN
// file — react-intl falls back to EN for any key missing here.
const common: Record<string, string> = {
  'app.name': 'GetPaid',
  'app.tagline': 'Receba pagamentos do exterior direto no seu Pix.',

  'common.nav.onboarding': 'Cadastro',
  'common.nav.invoices': 'Cobranças',
  'common.nav.affiliate': 'Afiliados',

  'common.copy': 'Copiar',
  'common.copied': 'Copiado',
  'common.cancel': 'Cancelar',
  'common.save': 'Salvar',
  'common.signOut': 'Sair',
  'common.loading': 'Carregando...',
  'common.error.generic': 'Algo deu errado. Tente novamente.',
};

export default common;
